<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información de la Tarjeta">
          <b-form>
            <app-banco
              label="Banco"
              :nombre="bancoNombre"
              :lista="bancosList"
              :valido="bancoValido"
              :msjInvalido="bancoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="bancoActualizado">
            </app-banco>  

            <app-tarjeta-marca
              label="Marca"
              :nombre="tarjetaMarcaNombre"
              :lista="tarjetasMarcasList"
              :valido="tarjetaMarcaValida"
              :msjInvalido="tarjetaMarcaInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="tarjetaMarcaActualizada">
            </app-tarjeta-marca>  

            <b-form-group
              label="Nro.Cuenta"
              label-for="numeroCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCuenta"
                v-model.trim="$v.numeroCuenta.$model" 
                :state="numeroCuentaValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroCuentaFeedback">
                {{ numeroCuentaInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Banco from '../shared/abmSelect.vue';
import TarjetaMarca from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjeta/getField',
  mutationType: 'tarjeta/updateField',
});

export default {
  name: 'TarjetaABM',
  components: {
    appBanco: Banco,
    appTarjetaMarca: TarjetaMarca,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      bancoValido: null,
      bancoInvalidoMsj: '',
      tarjetaMarcaValida: null,
      tarjetaMarcaInvalidaMsj: '',
      numeroCuentaValido: null,
      numeroCuentaInvalidoMsj: '',

      bancos: [],
      bancosList: [],
      tarjetasMarcas: [],
      tarjetasMarcasList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'banco',
      'bancoNombre',
      'tarjetaMarca',
      'tarjetaMarcaNombre',
      'numeroCuenta',
    ])
  },  
  created() {
    let tarjetaId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        tarjetaId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('tarjeta/inicializar', tarjetaId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('bancos/getBancosList')
        .then(() => {
          vm.bancos = this.$store.getters['bancos/bancosList']
          vm.bancosList = this.$store.getters['bancos/bancosSelectList']
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de bancos')));

      this.$store.dispatch('tarjetasmarcas/getTarjetasMarcasList')
        .then(() => {
          vm.tarjetasMarcas = this.$store.getters['tarjetasmarcas/tarjetasMarcasList']
          vm.tarjetasMarcasList = this.$store.getters['tarjetasmarcas/tarjetasMarcasSelectList']
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de marcas de tarjetas')));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numeroCuenta' || validarTodos) {
        if (this.$v.numeroCuenta.$error) {
          this.numeroCuentaValido = false;
          if (!this.$v.numeroCuenta.maxLength) {
            this.numeroCuentaInvalidoMsj = 'El número de cuenta solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.numeroCuentaValido = null;
          this.numeroCuentaInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = true;

      let banco = null;
      if (this.bancoNombre) {
        banco = this.getSelected(this.bancos, this.bancoNombre);
      }
      this.$store.dispatch('tarjeta/setBanco', banco);

      let tarjetaMarca = null;
      if (this.tarjetaMarcaNombre) {
        tarjetaMarca = this.getSelected(this.tarjetasMarcas, this.tarjetaMarcaNombre);
      }
      this.$store.dispatch('tarjeta/setTarjetaMarca', tarjetaMarca);

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('tarjeta/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      } 
    },
    goList() {
      this.$router.push({ name: "Tarjetas" });
    },
    bancoActualizado(bancoNombre) {
      this.bancoNombre = bancoNombre;
    },
    tarjetaMarcaActualizada(tarjetaMarcaNombre) {
      this.tarjetaMarcaNombre = tarjetaMarcaNombre;
    },
  },
  validations: {
    numeroCuenta: {
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
